import Layout from "../../components/layout/Layout";
import "../../assets/InnerCSS/plugins/bootstrap/css/bootstrap.min.css";
import "../../assets/InnerCSS/plugins/font-awesome/css/font-awesome.min.css";
import "../../assets/InnerCSS/plugins/icomoon/style.css";
import "../../assets/InnerCSS/plugins/uniform/css/default.css";
import "../../assets/InnerCSS/plugins/switchery/switchery.min.css";
import "../../assets/InnerCSS/plugins/nvd3/nv.d3.min.css";
import "../../assets/InnerCSS/css/styles.css";
import "../../assets/InnerCSS/css/custom.css";
import CandidateAccessComponent from "../../components/candidate/access/CandidateAccessComponent";
import { useHistory } from "react-router";

const CandidateAccess = () => {
    const history = useHistory();
    return (
        <Layout>
            <div className="breadcrumb-text">
                <a onClick={() => history.push("/")}>Home</a> <i className="fa-solid fa-angle-right"></i> Who Viewed Your Profile
            </div>
            <div className="page-title">
                <h4 className="breadcrumb-header"> WHO VIEWED YOUR PROFILE</h4>                
            </div>
            <CandidateAccessComponent />
        </Layout>
    );
};
export default CandidateAccess;